<template>
  <img
    class="object-cover"
    src="@/assets/images/navbar-icons/nav-improve-icon.webp"
  >
</template>